import React from "react";
import { Box, Link } from "@dealer-center/core-components";
import { TagManager } from "@dealer-center/core-third-party-gtm";
import { Locale } from "@dealer-center/ddc-core-utils";
import type { ResolvedSubLink } from "../applicationCardData";
import {
  CONTAINER_STYLES,
  LINK_STYLES,
  TYPOGRAPHY_STYLES
} from "../styleConstants";

interface ConfigurationCardLinksProps {
  subLinks: ResolvedSubLink[];
}

export const ConfigurationCardLinks: React.FC<ConfigurationCardLinksProps> = ({
  subLinks
}) => (
  <Box
    className="configuration-card-links"
    sx={CONTAINER_STYLES.subLinkInlineList}
    onClick={(e: React.MouseEvent) => e.stopPropagation()}
  >
    {subLinks.map((subLink, index) => (
      <React.Fragment key={subLink.key}>
        {index > 0 && (
          // decorative only — screen readers read the links, not the glyph
          <Box
            aria-hidden="true"
            component="span"
            sx={TYPOGRAPHY_STYLES.subLinkSeparator}
          >
            &middot;
          </Box>
        )}
        {/* Interstate's Link silently drops onClick (research R4) — the wrapping
          Box carries the click handler instead, exactly like the card body. */}
        <Box
          title={String(Locale.getText(subLink.hover))}
          onClick={() => {
            TagManager.event({
              eventName: "welcome_configuration_link_click",
              eventProperties: {
                component: "welcome-configuration-card",
                actionContext: "sub-link",
                label: subLink.key
              }
            });
          }}
        >
          <Link href={subLink.url} sx={LINK_STYLES.cardSubLink}>
            {subLink.label}
          </Link>
        </Box>
      </React.Fragment>
    ))}
  </Box>
);
